import { SessionRole } from '@salsita-ai/platform-contracts/api';
const DEALER_TAG = 'dealer';
const authenticatedRoles = [
    SessionRole.User,
    SessionRole.Admin,
    SessionRole.SuperAdmin
];
export const isDealer = (sessionPayload)=>{
    return sessionPayload.tags.includes(DEALER_TAG);
};
export const isAuthenticated = (session)=>{
    return authenticatedRoles.includes(session?.sessionPayload?.role ?? SessionRole.Anonymous);
};

//# sourceMappingURL=auth.js.map